import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="hero-section">
      {/* Background Blobs */}
      <div className="bg-blobs">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      {/* Grid Pattern */}
      <div className="grid-pattern" />

      {/* Floating Decorative Icons */}
      <div className="hero-float hero-float-1">🎬</div>
      <div className="hero-float hero-float-2">📺</div>
      <div className="hero-float hero-float-3">🎧</div>
      <div className="hero-float hero-float-4">🍿</div>

      {/* Hero Content */}
      <div className="hero-content">
        {/* Badge */}
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          استراحة الترفيه الأولى عبر الشبكات المحلية في اليمن
        </div>

        {/* Title */}
        <h1 className="hero-title">
          استمتع بتجربة{' '}
          <span className="highlight">سينمائية استثنائية</span>
          <br />
          دون{' '}
          <span className="highlight-gold">إنترنت خارجي</span>
        </h1>

        {/* Subtitle */}
        <p className="hero-subtitle">
          <strong>استراحة شاشتنا</strong> منصة ترفيه متكاملة تُقدَّم عبر شبكات
          الواي فاي المحلية في الفنادق والمقاهي والاستراحات، تتيح لك مشاهدة
          الأفلام والمسلسلات والبودكاست بجودة عالية وبدون أي اتصال بالإنترنت.
        </p>

        {/* CTA Buttons */}
        <div className="hero-buttons">
          <Link to="/about" className="btn-primary">
            <span>🎬</span>
            <span>اكتشف الاستراحة</span>
          </Link>
          <a
            href="https://wa.me/967783124226"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline"
          >
            <span>💬</span>
            <span>تواصل معنا</span>
          </a>
        </div>

        {/* Stats Row */}
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">+500</div>
            <div className="stat-label">فيلم ومسلسل</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">HD</div>
            <div className="stat-label">جودة عالية</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">دعم متواصل</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hero-scroll-indicator">
        <span className="hero-scroll-text">اكتشف المزيد</span>
        <span className="hero-scroll-mouse">
          <span className="hero-scroll-wheel" />
        </span>
      </div>
    </section>
  );
}

export default Hero;